import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { PolicyService } from '../../services/PolicyService';
import { AuthService } from '../../services/AuthService';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-policy-notification',
  templateUrl: './policy-notification.component.html',
  styleUrls: ['./policy-notification.component.css']
})
export class PolicyNotificationComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  showPolicyNotification = false;
  isChecked = false;

  constructor(
    private policyService: PolicyService,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    if (this.authService.isLoggedIn()) {
      this.policyService.checkPolicyAgreement().pipe(takeUntil(this.destroy$)).subscribe((agreed) => {
        this.showPolicyNotification = !agreed;

        if (this.showPolicyNotification) {
          // Для iOS Safari: рассчитываем реальный vh
          this.updateVH();
          window.addEventListener('resize', this.updateVH);

          // Блокируем скролл фона
          document.body.style.overflow = 'hidden';
        }
      });
    }
  }

  acceptPolicy(): void {
    this.policyService.acceptPolicy().pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.showPolicyNotification = false;

      // Возвращаем скролл
      document.body.style.overflow = '';

      // Убираем нашу переменную --vh, и слушатель resize
      document.documentElement.style.removeProperty('--vh');
      window.removeEventListener('resize', this.updateVH);
    });
  }

  ngOnDestroy(): void {
    // Если пользователь ушёл со страницы/компонента
    document.body.style.overflow = '';
    document.documentElement.style.removeProperty('--vh');
    window.removeEventListener('resize', this.updateVH);
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Метод для "vh хака" в iOS
  private updateVH = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };
}
